export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/2e5ee88f-4eca-408f-a417-8d1978011528.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/e7dfaf5d-eda5-4320-8ffb-89d9e9803dd0.png',
};
